import { render, staticRenderFns } from "./icon-select.vue?vue&type=template&id=88ec5f8c&scoped=true&"
import script from "./icon-select.vue?vue&type=script&lang=js&"
export * from "./icon-select.vue?vue&type=script&lang=js&"
import style0 from "./icon-select.vue?vue&type=style&index=0&id=88ec5f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ec5f8c",
  null
  
)

component.options.__file = "icon-select.vue"
export default component.exports